import { setBrowserMode } from '@/reducers/menus';
import { setUID } from '@/reducers/users';
import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { yixiaoMessage } from './utils';
import { setLocalStorageExpire } from './utils/cookie-tool';
import axios from '@/api/ai-axios';
import useAuth from '@/hooks/useAuth';

const YIXIAOHOC = (WrappedComponent) => {
  const SimpleComponent = (props) => {
    const { userData, uid } = props;

    const prevProps = useRef();
    const prevUid = useRef();
    const { checkLogin } = useAuth();

    useEffect(() => {
      // if (window.cFunNotifyAiWebLoadOver) {
      // 通知一校客户端加载完毕
      // window.cFunNotifyAiWebLoadOver('');
      window.notifyAiWebAccount = yixiaoLogin;
      // }
    }, []);

    useEffect(() => {
      const currentBalance = userData?.quotaInfo?.total_balance;

      // uid 变了，说明切换了账号，重置历史数据，避免跨账号比较
      if (uid !== prevUid.current) {
        prevUid.current = uid;
        prevProps.current = undefined;
        return;
      }

      const prevBalance = prevProps.current?.quotaInfo?.total_balance;

      if (
        currentBalance !== undefined &&
        prevBalance !== undefined &&
        currentBalance !== prevBalance
      ) {
        if (window.cFunNotifyAiScoreChange) {
          // 剩余积分 差值
          let diffScore = currentBalance - prevBalance || 0;
          const scoreChange = {
            score: userData?.quotaInfo?.total_balance,
            use: diffScore,
            uid: uid,
          };
          window.cFunNotifyAiScoreChange(`${JSON.stringify(scoreChange)}`);
        }
      }

      prevProps.current = userData;
    }, [userData, uid]);

    const yixiaoLogin = (params) => {
      try {
        const { account, password } = JSON.parse(params);
        if (!account || !password) {
          throw new Error('缺少参数,请检查账号和密码是否正确！');
        }

        axios
          .post('/api/yixiao/login', {
            account,
            password,
          })
          .then((data) => {
            if (data.status == 1) {
              props.handleSetUid(data.data.uid);
              let expiresTime = 60 * 24 * 30; // cookie过期时间, 单位：分钟
              setLocalStorageExpire('uid', data.data.uid, expiresTime);
              checkLogin();
            } else {
              yixiaoMessage(data.message);
            }
          })
          .catch((err) => {
            yixiaoMessage(`登录失败,${err.message}`);
          });
      } catch (err) {
        console.log(err);
        yixiaoMessage(`登录失败,${err.message}`);
      }
    };

    return <WrappedComponent {...props} />;
  };
  const mapStateToProps = (state) => ({
    browserMode: state.menus.browserMode,
    userData: state.users.data,
    uid: state.users.uid,
  });

  const mapDispatchToProps = (dispatch) => ({
    handleSetBrowserMode: (mode) => dispatch(setBrowserMode(mode)),
    handleSetUid: (data) => dispatch(setUID(data)),
  });

  return connect(mapStateToProps, mapDispatchToProps)(SimpleComponent);
};

export default YIXIAOHOC;
